/* @flow */
import * as React from 'react';

const HappyFace = props => (
  <svg
    width={30}
    height={30}
    viewBox="0 0 30 30"
    stroke="none"
    strokeWidth={1}
    fill="#FFF055"
    fillRule="evenodd"
    {...props}>
    <path d="M15,0 C6.729,0 0,6.729 0,15 C0,23.271 6.729,30 15,30 C23.271,30 30,23.271 30,15 C30,6.729 23.271,0 15,0 Z M15,28 C7.832,28 2,22.168 2,15 C2,7.832 7.832,2 15,2 C22.168,2 28,7.832 28,15 C28,22.168 22.168,28 15,28 Z" />
    <path d="M4,15 C4,18.468 5.618,21.562 8.133,23.58 C8.173,23.624 8.221,23.658 8.274,23.685 C10.136,25.13 12.466,26 15,26 C15.875,26 16.723,25.886 17.54,25.692 C17.603,25.687 17.662,25.673 17.716,25.647 C19.195,25.269 20.554,24.595 21.726,23.685 C21.779,23.658 21.827,23.623 21.867,23.58 C24.382,21.562 26,18.468 26,15 C26,14.724 25.776,14.5 25.5,14.5 L4.5,14.5 C4.224,14.5 4,14.724 4,15 Z M22,15.5 L24.987,15.5 C24.859,18.091 23.737,20.421 22,22.127 L22,15.5 Z M18,15.5 L21,15.5 L21,22.985 C20.104,23.66 19.094,24.19 18,24.535 L18,15.5 Z M13,15.5 L17,15.5 L17,24.797 C16.353,24.929 15.685,25 15,25 C14.315,25 13.647,24.929 13,24.797 L13,15.5 Z M9,15.5 L12,15.5 L12,24.535 C10.906,24.19 9.896,23.66 9,22.985 L9,15.5 Z M8,15.5 L8,22.127 C6.263,20.421 5.141,18.09 5.013,15.5 L8,15.5 Z" />
    <path d="M8.5,12 C8.776,12 9,11.776 9,11.5 C9,10.121 9.897,9 11,9 C12.103,9 13,10.121 13,11.5 C13,11.776 13.224,12 13.5,12 C13.776,12 14,11.776 14,11.5 C14,9.57 12.654,8 11,8 C9.346,8 8,9.57 8,11.5 C8,11.776 8.224,12 8.5,12 Z" />
    <path d="M16.5,12 C16.776,12 17,11.776 17,11.5 C17,10.121 17.897,9 19,9 C20.103,9 21,10.121 21,11.5 C21,11.776 21.224,12 21.5,12 C21.776,12 22,11.776 22,11.5 C22,9.57 20.654,8 19,8 C17.346,8 16,9.57 16,11.5 C16,11.776 16.224,12 16.5,12 Z" />
  </svg>
);

export default HappyFace;



// WEBPACK FOOTER //
// ./src/assets/images/icons/happy-face.js